import React from 'react';
import { styled, HtmlRenderer } from '@teko/ui';

const AttributeWrapper = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  &:nth-of-type(even) {
    background-color: #f6f6f6;
  }
`;
const Group = styled.div`
  padding: 12px 16px;
  font-weight: 700;
  color: #848788;
  word-break: break-word;
`;
const Name = styled.span`
  width: 40%;
  word-break: break-word;
  min-width: 40%;
`;
const Value = styled.span`
  color: black;
  width: 60%;
  word-break: break-word;
`;
const Specifications = ({
  attributeGroups
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, attributeGroups.filter((att) => !!att.value || !att.value && att.parentId === 0).map((att, index) => {
    if (att.parentId === 0) {
      return /* @__PURE__ */ React.createElement(Group, {
        key: index
      }, att.name);
    }
    return /* @__PURE__ */ React.createElement(AttributeWrapper, {
      key: index
    }, /* @__PURE__ */ React.createElement(Name, null, att.name), /* @__PURE__ */ React.createElement(Value, null, /* @__PURE__ */ React.createElement(HtmlRenderer, {
      content: att.value
    })));
  }));
};

export { Specifications };
